import { render } from "./DetailView.vue?vue&type=template&id=ab2b1758&scoped=true"
import script from "./DetailView.vue?vue&type=script&lang=js"
export * from "./DetailView.vue?vue&type=script&lang=js"

import "./DetailView.vue?vue&type=style&index=0&id=ab2b1758&lang=css&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\pwa-tahlil\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab2b1758"]])

export default __exports__